<template>
   <div class="member-add">
      <el-form  label-width="120px" :rules="rules" ref="memberForm" :model="memberForm" >
          <el-row>
              <el-col :lg="10" >
                  <el-form-item label="姓名:" prop="name">
                      <el-input v-model="memberForm.name"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="性別">
                      <el-radio-group v-model="memberForm.sex" >
                          <el-radio :label="2">男</el-radio>
                          <el-radio :label="1">女</el-radio>
                      </el-radio-group>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" >
                 <el-form-item label="生日:" prop="birthday">
                      <el-date-picker v-model="memberForm.birthday" type="date" placeholder="選擇日期"></el-date-picker>
                 </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="手機:" prop="phone">
                      <el-input v-model="memberForm.phone"></el-input>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" >
                  <el-form-item label="膚質:">
                      <el-input v-model="memberForm.skin"  style="width:50%;"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
                  <el-form-item label="婚姻狀況:">
                      <el-select v-model="memberForm.married" placeholder="">
                          <el-option v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                      </el-select>
                      
                  </el-form-item>
                  
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="22" >
                        <el-form-item label="地址:" prop="address" >
                             
                              
                              
                             
                               <el-select v-model="memberForm.city" placeholder="" @change="queryArea" :disabled="checkInputd" >
                               <el-option v-for="item in getCityItems"
                                   :key="item.city"
                                   :label="item.city"
                                   :value="item.city">
                               </el-option>
                           </el-select>
                           <el-select v-model="memberForm.area"  >
                               <el-option v-for="item in getAreaItems"
                                   :key="item.code"
                                   :label="item.area"
                                   :value="item.area">
                               </el-option>
                           </el-select>
                           
                               <el-input v-model="memberForm.address" style="width:50%;"></el-input>
                           
                    </el-form-item>
              </el-col>
              
          </el-row>
          <el-row>
              <el-col :lg="12" >
                  <el-form-item label="Email:">
                      <el-input v-model="memberForm.email"></el-input>
                  </el-form-item>
              </el-col>
             
          </el-row>
          <el-row>
              <el-col :lg="10" >
            <el-form-item label="店櫃:" prop="shop_key" >
                             <el-select v-model="memberForm.shop_key" @change="checkBrand">
                             <el-option v-for="item in shops"
                                 :key="item._key"
                                 :label="item.name"
                                 :value="item._key"
                                 clearable
                                 >
                             </el-option>
                         </el-select>
            </el-form-item>
               
             </el-col>
              <el-col :lg="10" >
                  <el-form-item label="品牌:">
                      <el-tag type="info" >{{this.brand_id}}</el-tag>
                      
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" >
                  <el-form-item label="美容師:">
                      <el-select v-model="memberForm.user_key" :disabled="memberForm.shop_key == '' ? true: false">
                          <el-option v-for="item in user"
                              :key="item._key"
                              :label="item.name"
                              :value="item._key">
                          </el-option>
                      </el-select>
                      
                  </el-form-item>
              </el-col>
              <el-col :lg="10" >
              <el-form-item label="推薦人卡號:">
                  <el-input v-model="memberForm.referrer_card_number" style="width:50%;" ></el-input>
                  
              </el-form-item>
              
              </el-col>
          </el-row>
          <el-row>
              <el-col :lg="10" :offset="2" >
                  <el-button type="primary" @click="addMember('memberForm')"> <i class="el-icon-plus" ></i>新增</el-button>
              </el-col>
              <el-col :lg="10" ></el-col>
          </el-row>
          
      </el-form>
   </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
    export default {
        name: 'Add',
        data() {
            return {
                memberForm:{
                    name: '',
                    sex: 1,
                    birthday: '',
                    phone: '',
                    skin: '',
                    brand_id:1,
                    email: '',
                    city: '',
                    area: '',
                    address: '',
                    shop_key: '',
                    user_key: '',
                    married: 1,
                    referrer_card_number: '',
                },
                checkInputd: false,
                clearForm: {
                          name: '',
                    sex: 1,
                    birthday: '',
                    phone: '',
                    skin: '',
                    brand_id:1,
                    email: '',
                    city: '',
                    area: '',
                    address: '',
                    shop_key: '',
                    user_key: '',
                    married: 1,
                    referrer_card_number: '',
                    
                },
                rules: {
                    name:[
                        {required: true, message: '請輸入名字'}
                    ],
                    birthday: [
                        {required: true, message: '請輸入生日'}
                    ],
                    shop_key: [
                        {required: true, message: '請輸入店櫃'}
                    ],
                    phone: [
                        {required: true, message: '請輸入手機號碼'}
                    ],
                     address: [
                        {required: true, message: '請輸入地址', trigger: 'blur'}
                    ]
                },
                options: [{
                    value: 1,
                    label: '未婚'
                },{
                      value: 2,
                      label: '已婚'  
                },{
                    value: 3,
                    label: '離婚'
                }
                ],
                shops: [],
                shop: [],
                user: [],
                brand_id: '',
                postcode: ''
            }
        },
        computed: mapGetters(["getAreaItems", "getCityItems", "getCodeItems", "beauticiansItems", "getShopDetail", "getShopList", "getError"]) ,
        methods: {
            ...mapActions(["fetchArea", "fetchCity", "fetchCode", "fetchShop", "addMember", "fetchShopDetail"]),
                 queryArea: function(){
            if(this.memberForm.area.length != 0){
                this.memberForm.area = ''
                 let city = this.memberForm.city
          let cityName = {city}
          this.$store.dispatch('fetchArea', cityName )
          
            }else {
                   let city = this.memberForm.city
          let cityName = {city}
          this.$store.dispatch('fetchArea', cityName )
          
            }
         },
          queryShop: function(){
             const data = {}
             this.$store.dispatch('fetchShop', data)
             .then(() => {
                 this.shops = this.getShopList
             }).catch((err) => {
                 console.log(err);
             });
         },
          async addMember(formName) {
            const strDate = moment(this.memberForm.birthday).format('YYYY-MM-DD')  
            const data = await {
                brand_id: this.memberForm.brand_id,
                name: this.memberForm.name,
                phone: this.memberForm.phone,
                married: this.memberForm.married,
                skin: this.memberForm.skin,
                sex: this.memberForm.sex,
                email: this.memberForm.email,
                city: this.memberForm.city,
                area: this.memberForm.area,
                address: this.memberForm.address,
                user_key: this.memberForm.user_key,
                shop_key: this.memberForm.shop_key,
                referrer_card_number: this.memberForm.referrer_card_number,
                birthday: strDate
            }
            this.$refs[formName].validate((valid) => {
                if(valid) {
                      this.$store.dispatch('addMember', data)
            if (this.getError === true) {
                this.$message({
                    message: '無法增加',
                    type: 'error'
                })
            }else {
                this.$emit('back')
                this.$refs[formName].resetFields();
                  this.memberForm = this.clearForm
               
            }
                }else {
                      this.$message({
                    message: '無法增加',
                    type: 'error'
                })
                }
            })
          
         },
         
         checkBrand: async function () {
           const data = await {_key: this.memberForm.shop_key} 
           await this.$store.dispatch('fetchShopDetail', data) 
         
               this.memberForm.brand_id = await this.getShopDetail.brand_id 
            if( this.memberForm.brand_id== 1){
                   this.brand_id = await 'N牌'
            }else {
                   this.brand_id = await 'S牌'
            }
               this.user = await this.beauticiansItems
           
         },
            changeBack(){
                this.$emit('back', this.back)
            },
            checkCode(){
                const data = {
                    city: this.memberForm.city,
                    area: this.memberForm.area
                }
                this.$store.dispatch('fetchCode', data)
                this.postcode = this.getCodeItems[0].code
                
            }
        },
        created() {
            this.fetchCity()
            this.queryShop()
        },
    }
</script>

<style  lang="scss" scoped>
    .el-form {
        margin: 0 auto;
        padding: 0;
        
        color: aqua;
           font-weight: bold;
         font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
         a{
             
             font-weight: bold;
         }
    }
</style>